export interface PagelevelFilterState {
  [filterId: string]: any;
}

export const initialPagelevelFilterState: PagelevelFilterState = {};
